import { api, ENDPOINTS, registerRefreshHandler, tokenStorage } from './api';
import type { LoginRequest, LoginResponse, User } from '@/types';

export const authService = {
  async login(payload: LoginRequest): Promise<LoginResponse> {
    const { data } = await api.post<LoginResponse>(ENDPOINTS.auth.login, payload);
    tokenStorage.setTokens(data.accessToken, data.refreshToken);
    return data;
  },

  async logout(): Promise<void> {
    try {
      await api.post(ENDPOINTS.auth.logout);
    } finally {
      tokenStorage.clear();
    }
  },

  async me(): Promise<User> {
    const { data } = await api.get<User>(ENDPOINTS.auth.me);
    return data;
  },

  async refresh(): Promise<string | null> {
    const refreshToken = tokenStorage.getRefreshToken();
    if (!refreshToken) return null;
    try {
      const { data } = await api.post<{ accessToken: string; refreshToken: string }>(
        ENDPOINTS.auth.refresh,
        { refreshToken },
      );
      tokenStorage.setTokens(data.accessToken, data.refreshToken);
      return data.accessToken;
    } catch {
      tokenStorage.clear();
      return null;
    }
  },
};

// Register refresh handler with axios interceptor
registerRefreshHandler(() => authService.refresh());
